<template>
    <div>
        <router-view :member="currentMember"></router-view>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'Member',
        props: ['cert'],
        mounted () {
            this.getMemberData(this.cert)
        },
        methods: {
            ...mapActions(['getMemberData'])
        },
        computed: {
            ...mapGetters(['currentMember'])
        }
    }
</script>

<style scoped>

</style>
